module.exports = __webpack_public_path__ + "static/img/home_type_icon_zyzd.8765a6de.webp";